@use './variables' as *;

:export {
  privoroBlue: $privoro-blue;
  privoroLightBlue: $privoro-light-blue;
  privoroLightBlueTranslucent: $privoro-light-blue-translucent;
  privoroLightBlueTranslucentHighlight: $privoro-light-blue-translucent-highlight;
  privoroIconBackBlue: $privoro-icon-back-blue;
  privoroGold: $privoro-gold;
  privoroGoldTranslucent: $privoro-gold-translucent;
  privoroRed: $privoro-red;
  privoroRedTranslucent: $privoro-red-translucent;
  privoroDarkestGray: $privoro-darkest-gray;
  privoroGray: $privoro-gray;
  privoroMediumGray: $privoro-medium-gray;
  privoroGrayLight: $privoro-medium-gray-light;
  privoroLightGray: $privoro-light-gray;
  privoroLightGrayBG: $privoro-light-gray-background;
  privoroDividerGray: $privoro-divider-gray;
  privoroOffwhite: $privoro-off-white;
  privoroTableBorder: $privoro-table-border;
  privoroTableHeadBottomBorder: $privoro-table-head-bottom-border;
  privoroHighlight: $highlight;
  privoroFocus: #b2dce2;
  privoroGold: $privoro-gold;
  privoroGreen: $privoro-green;
  red: $red;
  jsRowHeight: $jsRowHeight;
  white:  $white ;
  offwhite: $offwhite;
  black:  $black ;
  yellow: $privoro-gold ;
  blue:   $privoro-blue ;
  
  // Create grayscale
  grayDark:                 $gray-dark ;
  gray:                     $gray ;
  grayLight:                $gray-light ;
  grayLighter:              $gray-lighter ;
  grayLightest:             $gray-lightest ;
  privoroOffGray:           $privoro-off-gray;



  // Reassign color vars to semantic color scheme
  brandPrimary:             $blue ;
  brandSuccess:             $green ;
  brandInfo:                $teal ;
  brandWarning:             $orange ;
  brandDanger:              $red ;
  brandInverse:             $gray-dark ;

  //NEW
  privoroButtonBg: $white;
  privoroButtonText: $black;
}
